import { apiErrorMessage } from '@/lib/api-error'
import { notification } from '@/notifications/notification-store'

export const notifyError = (fallback: string) => (err: unknown) => notification.error(apiErrorMessage(err, fallback))
